/**
 * Created by IMRANEXPT on 1/24/16.
 */
(function() {
    /** @ngInject */
    function paymentPageController($scope, Booking, Utils){
        $scope.haveMenuProduct = function(){
            return _.find(Booking.booking_products, {meal_type : 'Menu'});
        }
    }
    angular.module("Waiteraid").controller("paymentCtrl", paymentPageController);
})();
